import { NgIf } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { HelperFunctions, ISubPhoto } from '@curbnturf/entities';
import { Logger } from '@curbnturf/network';
import { IPhoto } from '@curbnturf/objects';
import { IonicModule, ModalController } from '@ionic/angular';
import { ImageUploadOptions } from '../image-upload-options';
import { ImageUploaderBaseComponent } from '../image-uploader-base/image-uploader-base.component';

@Component({
  selector: 'curbnturf-image-recrop-modal',
  templateUrl: './image-recrop-modal.component.html',
  styleUrls: ['./image-recrop-modal.component.scss'],
  standalone: true,
  imports: [IonicModule, NgIf, ImageUploaderBaseComponent],
})
export class ImageRecropModalComponent implements OnInit {
  @Input() photo: IPhoto;

  @Input() options: ImageUploadOptions;

  croppieImage: string;
  originalBlob: Blob;
  maxDimensions: { width: number; height: number };

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Input() saveFunction: (files: any) => void;

  constructor(
    private modalController: ModalController,
    private logger: Logger,
  ) {}

  async ngOnInit() {
    const originalPhotoUrl = HelperFunctions.getPhotoUrlFullSize(this.photo as ISubPhoto);
    this.croppieImage = originalPhotoUrl;

    fetch(originalPhotoUrl)
      .then((response) => response.blob())
      .then((blob) => {
        this.originalBlob = blob;
      })
      .catch((error) => {
        this.logger.error('Failed to retrieve original image blob.', error);
      });
  }

  async close() {
    await this.modalController.dismiss();
  }

  protected readonly origin = origin;
}
